import { storefrontClient } from '@nova/storefront'

class GiftCardBalance extends HTMLElement {
  constructor() {
    super()

    this.variantId = this.dataset.variantId
    this.variantPrice = this.dataset.variantPrice
    this.giftCodeInput = this.querySelector('.gift-card-balance__input')
    this.btn = this.querySelector('.gift-card-balance__atc')
    this.messageBox = this.querySelector('.gift-card-balance__response')
    this.usedBox = this.querySelector('[used-message]')
    this.errorBox = this.querySelector('[error-message]')
    this.balanceBox = this.querySelector('[balance-message]')
    this.balancePriceBox = this.querySelector('[balance]')

    this.onCheckBalance = this.onCheckBalance.bind(this)
  }

  async connectedCallback() {
    this.btn.addEventListener('click', this.onCheckBalance)
  }

  disconnectedCallback() {
    this.btn.removeEventListener('click', this.onCheckBalance)
  }

   formatAmount(value) {
    const rounded = Math.round((Number(value) + Number.EPSILON) * 100) / 100;
    return rounded.toFixed(2);
  }

  async onCheckBalance() {
    const giftCode = this.giftCodeInput.value.trim()
    if (giftCode === '') {
      this.giftCodeInput.value = ''
      setTimeout(() => this.giftCodeInput.focus(), 50)
      return
    }

    try {
      const cart = await storefrontClient.cartCreate(this.variantId)
      const data = await storefrontClient.cartGiftCardCodesUpdate(cart.id, giftCode)
      if (data.appliedGiftCards.length) {
        const appliedGiftCard = data.appliedGiftCards[0]
        const balance = Number(appliedGiftCard.balance.amount) + Number(this.variantPrice)
        this.balancePriceBox.textContent = this.formatAmount(balance)
        this.balanceBox.classList.remove('hidden')
        this.usedBox.classList.add('hidden')
        this.errorBox.classList.add('hidden')
      } else {
        this.balanceBox.classList.add('hidden')
        this.errorBox.classList.add('hidden')
        this.usedBox.classList.remove('hidden')
      }
      this.messageBox.classList.remove('hidden')
    } catch (e) {
      this.balanceBox.classList.add('hidden')
      this.usedBox.classList.add('hidden')
      this.errorBox.classList.remove('hidden')
      this.messageBox.classList.remove('hidden')
    }
  }
}

customElements.define('gift-card-balance', GiftCardBalance)
